import { Button } from "@mui/material";
import type { FC } from "react";

interface Props {
  readonly onClick: () => void | Promise<void>;
}

const CreateCalculationButton: FC<Props> = ({ onClick }) => (
  <Button variant="outlined" color="secondary" onClick={onClick}>
    Utwórz kalkulację
  </Button>
);

export default CreateCalculationButton;
